import { addProp } from "@pnp/odata";
import { _Folder } from "../folders/types.js";
import { Files } from "./types.js";
addProp(_Folder, "files", Files);
//# sourceMappingURL=folder.js.map